<template>
    <div class="page">
        <div class="infoBox">
			<div class="info">
                <div class="title">{{ title }}</div>
			</div>
		</div>
        <div class="player-item">
            <div id='player'></div>
            <img class="icon" src="./../assets/bigvideo_icon@2x.png" alt="" @click="getData" v-if="showPlayIcon">
        </div>
        <!-- <input type="text" v-model="url">
        <div @click="getData">刷新</div> -->
    </div>
</template>

<script>
    import Apis from '../config/apis'
    import PlayerManager from '/public/icc/PlayerManager.js'
    export default {
        data () {
            return {
                player: null,
                // url: 'ws://220.176.1.74:559/openUrl/Wqz6me4',
                url: '',
                splitNum: 1,
                mode: 0,
                title: '慢直播',
                sid: '',
                code: '',
                showPlayIcon: true,
                link: '',
                realPlayer: {},
                data: {},
            }
        },
        mounted() {
            document.getElementById('index-loading-box').className = 'index-loading-box hide'

            this.link = this.$route.query.link
            if(this.$route.query.title) this.title = this.$route.query.title

            document.title = this.title
            
            this.createPlayer()
            // this.getData()
        },
        methods: {
            getData() {
                this.showPlayIcon = false
                this.axios.post(Apis.liveSlowDetail, {
                    link: this.link
                }).then((res) => {
                    this.data = res.data
                    this.$nextTick(() => {
                        // setTimeout(() => {
                            this.realplay()
                        // }, 3000)
                    })
                })
            },

            createPlayer () {
                let url = location.pathname.substring(1)
                let prefixUrl = `${ url }lib`

                this.realPlayer = new PlayerManager({
                    el: 'player',
                    type: 'real',
                    maxNum: 4,
                    num: 1,
                    showControl: false,
                    // prefixUrl: 'h5s/lib', // 线上
                    // prefixUrl: 'lib', // 本地
                    prefixUrl,
                    receiveMessageFromWSPlayer: (method, data) => {
                        switch(method) {
                            // ------------- 公共事件 ---------------------
                            case 'initializationCompleted':
                                // 初始化完成，可调用播放方法（适用于动态加载解码库）
                                console.info('初始化完成')
                                // this.getData()
                                break
                            case 'realSuccess': // 实时预览成功
                                console.log('实时预览成功')
                                break
                            case 'realError': // 实时预览失败
                                console.log('实时预览失败')
                                break
                            case 'talkError': // 对讲失败
                                console.log('对讲失败')
                                break
                            case 'recordSuccess': // 录像回放成功
                                console.log('录像回放成功')
                                break
                            case 'recordError': // 录像回放失败
                                console.log('录像回放失败')
                                break
                            case 'recordFinish':
                                console.log('当前录像播放完成', data)
                                break
                            case 'selectWindowChanged': // 选中的窗口发生改变
                                break
                            case 'windowNumChanged': // 播放器显示的路数发生改变
                                break
                            case 'closeVideo': // 视频关闭
                                // 点击关闭按钮引发的视频关闭进行提示
                                // 切换视频引发的视频关闭不进行提示
                                if(!data.changeVideoFlag) {
                                    console.log(`窗口${data.selectIndex}的视频已关闭`)
                                }
                                break
                            case 'statusChanged': // 视频状态发生改变
                                break
                            case 'getVideoFrameInfo':
                                // 获取视频帧信息
                                break
                            case 'getAudioFrameInfo':
                                // 获取视频内音频帧信息
                                break
                            case 'getPlayBackStreamRange':
                                // 获取录像回放时长
                                console.log('getPlayBackStreamRange', data)
                                break
                            case 'dragWindow':
                                // 拖拽窗口
                                console.log(`窗口${data.dragIndex}的视频拖拽到窗口${data.dropIndex}上`)
                                break
                            case 'errorInfo': // 错误信息提示
                                console.log(data, '可打印查看错误消息')
                                // data = {
                                //     errorCode: xxx,
                                //     errorMsg: "",
                                //     errorData: {
                                //         channelList: [],
                                //         apiErrorInfo: {},
                                //         method: "",
                                //         arguments: [],
                                //     },
                                // }
                                console.error(data)
                                break
                            case 'picCap': // 抓图回调，配置在 new PlayerManager 中配置 picCapCb为true后即可触发
                                // data.index 窗口索引
                                // data.base64Img
                                break
                            default:
                                break
                        }
                    }
                })
            },
            realplay() {
                this.realPlayer.realByUrl({
                    rtspURL: this.data.rtsp_url,
                    wsURL: this.data.ws_url,
                    // wsURL: 'wss://222.223.101.137:9100',
                    selectIndex: 0,
                    streamType: 1,
                    playerAdapter: 'selfAdaption',
                    channelId: '1000000$1$0$0',
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.page {
    min-height: 100vh;
	background-color: #ffffff;
    padding-bottom: 1rem;
    box-sizing: border-box;
    text-align: left;
    background: url('https://ts.hbysp.cn/upload/uediter/image/20250313/1741848166407408.png') 0 0 / 100% 100% no-repeat;
    .player-item {
        position: relative;
        width: 100%;
        height: 4rem !important;
        #player {
            width: inherit;
            height: inherit;
        }
        .icon {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: .80rem;
            height: .80rem;
            padding: .20rem;
            background: #858585;
            box-sizing: content-box;
            border-radius: 50%;
            z-index: 11111;
        }
    }
    .infoBox{
        width: 6.9rem;
        padding: .60rem .30rem .70rem;
        display: flex;
        position: relative;
        .info{
            position: relative;
            // margin-left: .2rem;
            flex: 1;
            .title{
                font-size: .30rem;
                font-weight: 500;
                color: #FFFFFF;
                // line-height: 50rpx;
                line-height: 1.2;
            }
            .list{
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: .26rem;
                font-weight: 400;
                color: #333333;
                margin-top: .3rem;
                line-height: 1.2;
                .left{
                    flex: 1;
                }
            }
            .bottom {
                position: absolute;
                bottom: .14rem;
            }
            .bottom1 {
                position: absolute;
                bottom: .4rem;
            }
        }
    }
}
</style>